import React from "react";
import styles from "./style.module.scss";
import PitBoostCorrectedLeaderboard from "../../../components/Timing/PitBoostCorrectedLeaderboard";
import VirtualGapsDataManager from "../../../components/DataManagers/VirtualGapsDataManager";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";
import AttackModeDataManager from "../../../components/DataManagers/AttackModeDataManager";

function PitBoostLeaderboardPage() {
  return (
    <div className={styles.fullscreen}>
      <TimingDataManager />
      <VirtualGapsDataManager />
      <ImportsDataManager />
      <AttackModeDataManager />
      <PitBoostCorrectedLeaderboard compact={true} />
    </div>
  );
}

export default PitBoostLeaderboardPage;
